module.exports = __webpack_public_path__ + "img/avatar-s-15.125ba632.jpg";